export enum Operator {
  LT = '<',
  LTE = '<=',
  EQ = '=',
  NEQ = '!=',
  GTE = '>=',
  GT = '>',
  REG = '=~',
}
